<ng-container>
  @if (currentCartId) {
    <div class="mini-cart__actions">
      <div class="mini-cart__name">
        @if (usersCarts?.length === 1) {
          <h5 class="current-cart-name">
            {{ currentCartName }}
          </h5>
        }
        @if (usersCarts?.length > 1) {
          <app-dropdown [dropDownName]="'miniCart-name'">
            <ng-container ngProjectAs="[slot][toggle]">
              <button class="button button--link mini-cart__btn-name">
                <h5>{{ currentCartName }}</h5>
                <span class="icon-arrow-down"></span>
              </button>
            </ng-container>
            <ng-container ngProjectAs="[slot][panel]">
              <ng-container>
                @for (cart of usersCarts; track cart.id) {
                  <span
                      class="menu__item"
                      [ngClass]="{'hidden': cart.id === currentCartId}"
                      (click)="switchDefaultCart(cart.id)">
                    {{ cart.name }}
                  </span>
                }
              </ng-container>
            </ng-container>
          </app-dropdown>
        }
      </div>
      <div class="mini-cart__settings">
        <app-dropdown [dropDownName]="'miniCart-settings'">
          <ng-container ngProjectAs="[slot][toggle]">
            <button class="button button--link mini-cart__btn-settings">
              <h5>{{ 'mini-cart.quote-settings' | translate }}</h5>
              <span class="icon-arrow-down"></span>
            </button>
          </ng-container>
          <ng-container ngProjectAs="[slot][panel]">
            <span class="menu__item" (click)="showAddNicknameModalEmit()">
              {{ getAddOrEditNicknameLabel() | translate }}
            </span>
            <span class="menu__item" (click)="showDeleteQuoteModalEmit()">
              {{ 'mini-cart.delete-quote' | translate }}
            </span>
          </ng-container>
        </app-dropdown>
      </div>
    </div>
  }
  @if (itemsInCart?.length > 0) {
    <div class="mini-cart__items">
      <div class="overflow-gradient"></div>
      <div class="items-list">
        @for (item of itemsInCart; track $index) {
          <div class="item-row">
            <div class="item-col-img">
              <img [src]="getItemPicture(item)" [alt]="item.attributes.name">
            </div>
            <div class="item-col-desc" [attr.data-test]="'desc-minicartItemName-'+item.attributes.name">
              <a [routerLink]="['/product/', item.attributes.abstractSku]" (click)="closeMiniCartAfterClickOnLink()">
                {{ item.attributes.name }}</a>
              <div class="item-col-desc__items">
                {{ 'mini-cart.equType' | translate:{count: getEquipmentCount(item)} }}<br>
                {{ 'mini-cart.fls' | translate:{count: item.items.length} }}
                @if (getItemPrice(item)) {
                  <span class="item-col-price">
                    {{ getItemPrice(item) | currency:currency }}
                  </span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-container>
